export const PLAY_AUDIO_TEXT = {
    id: 'oe.audioWave.play',
    defaultMessage: 'Play audio',
    description: 'Accessible label of the audio play button'
};

export const PAUSE_AUDIO_TEXT = {
    id: 'oe.audioWave.pause',
    defaultMessage: 'Pause audio',
    description: 'Accessible label of the audio pause button'
};
